import { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/sports-betting/board`;
const fmtMl = (v) => (v == null ? '—' : v > 0 ? `+${v}` : `${v}`);

const Row = ({ k, v, testid }) => (v ? <p className="text-[11px] text-zinc-400" data-testid={testid}><span className="text-zinc-500">{k}:</span> {v}</p> : null);

const pc = (v) => (v == null ? null : `${Math.round(v * 100)}%`);
const WinChance = ({ pk }) => (
  <div className="rounded bg-emerald-500/10 border border-emerald-500/30 px-2 py-1.5" data-testid="cfb-detail-winchance">
    <p className="text-[11px] font-bold text-emerald-300">Chance {pk.abbr} wins outright: {pc(Math.min(0.99, pk.prob))}</p>
    <p className="text-[10px] text-zinc-400">
      {[['Sportsbook', pk.market_prob], ['ESPN', pk.fpi_prob], ['Team form', pk.form_prob]].filter(([, v]) => v != null).map(([k, v]) => `${k} ${pc(Math.min(0.99, v))}`).join(' · ')}
    </p>
  </div>
);

// Expanded game card: live book odds, ESPN FPI, weather, venue, team news + the model's reasons.
export const CfbGameDetail = ({ g }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API}/cfb/game/${g.event_id}`).then((r) => setD(r.data)).catch(() => setD({}));
  }, [g.event_id]);
  const [away, home] = [g.teams.find((t) => t.home_away === 'away'), g.teams.find((t) => t.home_away === 'home')];
  const w = d?.weather || {};
  return (
    <div className="mt-1 mb-2 ml-8 rounded-lg bg-zinc-950/70 border border-zinc-800 p-2.5 space-y-1" data-testid={`cfb-detail-${g.event_id}`}>
      {d === null ? <p className="text-[11px] text-zinc-500 flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> Getting latest info…</p> : (
        <>
          <WinChance pk={g.pick} />
          <Row k={`Moneyline (${d.odds?.book || 'book'})`} v={d.odds && (d.odds.away_ml != null || d.odds.home_ml != null) && `${away?.abbr} ${fmtMl(d.odds.away_ml)} / ${home?.abbr} ${fmtMl(d.odds.home_ml)}`} testid={`cfb-detail-odds-${g.event_id}`} />
          <Row k="ESPN win chance" v={d.fpi && Object.entries(d.fpi).map(([t, p]) => `${t} ${p}%`).join(' · ')} />
          <Row k="Weather" v={w.temperature != null && `${w.temperature}°F · gusts ${w.gust ?? 0} mph · ${w.precipitation ?? 0}% rain`} />
          <Row k="Stadium" v={d.venue && `${d.venue}${d.city ? ` · ${d.city}` : ''}${d.grass === false ? ' · turf' : ''}`} />
          <Row k="Against the spread" v={d.ats && Object.entries(d.ats).map(([t, r]) => `${t} ${r}`).join(' · ')} />
          <p className="text-[10px] text-zinc-600" data-testid={`cfb-detail-spread-${g.event_id}`}>Spread info (not used for picks): {d.odds?.line || '—'} · O/U {d.odds?.over_under ?? '—'}</p>
          {(d.news || []).length > 0 && (
            <div data-testid={`cfb-detail-news-${g.event_id}`}>
              <p className="text-[11px] text-zinc-500">Team news:</p>
              {d.news.map((n) => <p key={n} className="text-[11px] text-amber-200/90 pl-2">• {n}</p>)}
            </div>
          )}
        </>
      )}
    </div>
  );
};
